/**
 * Единицы измерения страницы: миллиметры ↔ пиксели.
 *
 * 01-SPEC.md §3.10.3 и docs/04-PROMPT-FIXTURES.md §7: при 300 dpi 1 мм = 11.811 px.
 * Все функции чистые.
 */
/** Миллиметров в дюйме. */
export const MM_PER_INCH = 25.4;
/** Пунктов (pt) в дюйме — типографский пункт PostScript, он же CSS `pt`. */
export const PT_PER_INCH = 72;
/** Сколько пикселей приходится на миллиметр при заданном dpi (без округления). */
export function pxPerMm(dpi) {
    return dpi / MM_PER_INCH;
}
/** Миллиметры → пиксели при заданном dpi, округление к ближайшему целому. */
export function mmToPx(mm, dpi) {
    return Math.round(mm * pxPerMm(dpi));
}
/**
 * Миллиметры → пиксели с округлением **вверх**.
 * Используется только для вылетов: недобор вылета — брак на резке,
 * поэтому здесь округляем в большую сторону (docs/04-PROMPT-FIXTURES.md §7).
 */
export function mmToPxCeil(mm, dpi) {
    return Math.ceil(mm * pxPerMm(dpi));
}
/** Пиксели → миллиметры при заданном dpi (без округления). */
export function pxToMm(px, dpi) {
    return px / pxPerMm(dpi);
}
/** Пункты → миллиметры. */
export function ptToMm(pt) {
    return (pt * MM_PER_INCH) / PT_PER_INCH;
}
/** Миллиметры → пункты. */
export function mmToPt(mm) {
    return (mm * PT_PER_INCH) / MM_PER_INCH;
}
/** Округление до заданного числа знаков после запятой (борьба с шумом float). */
export function roundTo(value, digits) {
    const factor = 10 ** digits;
    return Math.round(value * factor) / factor;
}
//# sourceMappingURL=units.js.map